export const creditKeys = {
  all: ["credits"] as const,
  balances: () => [...creditKeys.all, "balances"] as const,
  // Its own branch rather than a child of `balances()`: that key already holds
  // the every-account balance list, and one key cannot be both a leaf and a
  // prefix over a different payload shape.
  accountBalance: (accountId: string) => [...creditKeys.all, "account-balance", accountId] as const,
  lists: () => [...creditKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...creditKeys.lists(), filters] as const,
  details: () => [...creditKeys.all, "detail"] as const,
  detail: (id: string) => [...creditKeys.details(), id] as const,
  applications: () => [...creditKeys.all, "applications"] as const,
  applicationList: (filters: Record<string, unknown>) =>
    [...creditKeys.applications(), filters] as const,
};

export const customerCreditKeys = {
  all: ["customer-credits"] as const,
  lists: () => [...customerCreditKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...customerCreditKeys.lists(), filters] as const,
};
